import { defineComponent as _defineComponent } from 'vue'
import LogOut from './LogOut.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderLogoutButton',
  setup(__props) {


return { __sfc: true,LogOut }
}

})